import styled, { css } from 'styled-components';

interface WrapperProps {
  height: string;
}

export const Wrapper = styled.div<WrapperProps>`
  ${({ height }) => css`
    height: ${height};
    margin: 0 -16px;
  `}
`;

export const MarkerImage = styled.img`
  width: 40px;
  position: absolute;
  top: calc(50% - 40px);
  left: calc(50% - 20px);
  z-index: 100;
`;
